


  <kendo-dialog-titlebar>
    {{'claims-center.claimDocumentation.deliveredDocuments' | translate}}
</kendo-dialog-titlebar>

<app-show-documents-multiple [referenceType]="proofDocumentReferenceType" [referenceId]="proofDocumentId"></app-show-documents-multiple>

<kendo-dialog-actions>
    <button kendoButton (click)="cancel()" [primary]="true" submit>
        <span>{{'global.close' | translate}}</span>
    </button>
</kendo-dialog-actions>
